import { IMAGES } from "@/lib/data";
import { Reveal, MaskedLines } from "./motion";

const CHAPTERS = [
  {
    n: "I.",
    title: "Il mare a due passi",
    text: "A Cavi di Lavagna il pesce arriva fresco ogni giorno. Lo selezioniamo con cura e lo portiamo in tavola come vuole la tradizione ligure: semplice, onesto, di stagione.",
  },
  {
    n: "II.",
    title: "La cucina di casa",
    text: "Trofie al pesto genovese, muscoli alla marinara, spaghetti alla spezzina. Piatti che raccontano la riviera, preparati come li farebbe la nonna, senza fronzoli.",
  },
  {
    n: "III.",
    title: "Dal mattino a notte fonda",
    text: "Bar, ristorante e gelateria insieme: colazioni al banco, aperitivi vista mare, gelati artigianali e cene di pesce. Dalle 6:30 alle 2:00, ogni giorno, un posto dove ti senti a casa.",
  },
];

export default function About() {
  return (
    <section id="chi-siamo" className="relative bg-bone py-24 sm:py-32 grain">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left: heading + image */}
          <div className="lg:col-span-5">
            <span className="text-xs tracking-[0.25em] uppercase font-sans font-semibold text-terracotta">
              Chi siamo
            </span>
            <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-charcoal">
              <MaskedLines lines={["Una tavola", "ligure, con"]} />
              <MaskedLines lines={["l'anima di mare."]} lineClassName="italic text-terracotta" delay={0.1} />
            </h2>

            <Reveal delay={0.15} className="mt-9 overflow-hidden rounded-sm">
              <img
                src={IMAGES.interior}
                alt="Sala interna del Bar Ristorante Gabri a Lavagna"
                className="w-full h-[340px] sm:h-[420px] object-cover hover:scale-[1.04] transition-transform duration-[1200ms] ease-out"
              />
            </Reveal>
          </div>

          {/* Right: manifesto chapters */}
          <div className="lg:col-span-6 lg:col-start-7 lg:pt-8">
            <div className="flex flex-col divide-y divide-charcoal/10">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.08} className="py-8 first:pt-0">
                  <div className="flex gap-6 sm:gap-8">
                    <span className="font-serif italic text-4xl sm:text-5xl text-terracotta/40 leading-none shrink-0 w-14">
                      {c.n}
                    </span>
                    <div>
                      <h3 className="font-serif text-2xl sm:text-3xl text-charcoal mb-2">{c.title}</h3>
                      <p className="font-sans text-pebble text-base leading-relaxed max-w-md">{c.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
